const ALLOWED_SENDING_MODES = new Set([
  'send_now',
  'schedule_once',
  'interval',
  'yearly_date',
]);

function toSendingMode(uiSendMode) {
  if (uiSendMode === 'scheduled') return 'schedule_once';
  return uiSendMode;
}

function toScheduleType(sendingMode) {
  if (sendingMode === 'interval' || sendingMode === 'yearly_date') {
    return sendingMode;
  }
  return 'scheduled';
}

/**
 * Map TemplateScheduleOptions payload → reminder import confirm body.
 */
export function buildReminderImportConfirmPayload({
  previewToken,
  duplicateAction,
  missingAction,
  scheduleResult,
  duplicatePhones,
  subject,
}) {
  if (!previewToken) {
    throw new Error('Preview expired. Upload the file again.');
  }

  const sendingMode = toSendingMode(scheduleResult?.sendMode);
  if (!ALLOWED_SENDING_MODES.has(sendingMode)) {
    throw new Error('Choose a sending mode.');
  }

  const schedule = scheduleResult?.schedule || {};

  const payload = {
    preview_token: previewToken,
    sending_mode: sendingMode,
    schedule_type: toScheduleType(sendingMode),
    schedule_name: schedule.name || '',
    duplicate_action: duplicateAction || 'keep_both',
    missing_action: missingAction,
    stop_on_reply: schedule.stop_on_reply ?? true,
    subject: subject || '',
  };

  if (Array.isArray(duplicatePhones)) {
    payload.duplicate_phones = duplicatePhones;
  }

  if (sendingMode === 'send_now') {
    return payload;
  }

  if (sendingMode === 'schedule_once' || sendingMode === 'yearly_date') {
    if (!schedule.scheduled_date_time) {
      throw new Error(
        sendingMode === 'yearly_date'
          ? 'Please select a time of day.'
          : 'Please select a schedule date & time.',
      );
    }
    payload.scheduled_date_time = schedule.scheduled_date_time;
    return payload;
  }

  if (
    !Number.isFinite(schedule.interval_value) ||
    schedule.interval_value < 1
  ) {
    throw new Error('Interval value must be at least 1.');
  }

  payload.interval_value = schedule.interval_value;
  payload.interval_unit = schedule.interval_unit;
  if (!schedule.start_date) {
    throw new Error('Please select a start date & time.');
  }
  payload.start_date = schedule.start_date;
  if (schedule.end_date) {
    payload.end_date = schedule.end_date;
  }
  if (schedule.max_attempts != null) {
    payload.max_attempts = schedule.max_attempts;
  }
  return payload;
}
